var _circle, _path;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgReminderCancel = function SvgReminderCancel(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#EDF2F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.273 9.33686C10.9801 9.04396 10.5052 9.04396 10.2123 9.33686C9.91945 9.62975 9.91945 10.1046 10.2123 10.3975L14.9329 15.1181L10.2123 19.8386C9.91945 20.1315 9.91945 20.6064 10.2123 20.8993C10.5052 21.1922 10.9801 21.1922 11.273 20.8993L15.9936 16.1787L20.7141 20.8993C21.007 21.1922 21.4819 21.1922 21.7748 20.8993C22.0677 20.6064 22.0677 20.1315 21.7748 19.8386L17.0542 15.1181L21.7748 10.3975C22.0677 10.1046 22.0677 9.62975 21.7748 9.33686C21.4819 9.04396 21.007 9.04396 20.7141 9.33686L15.9936 14.0574L11.273 9.33686Z",
    fill: "#071827"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReminderCancel, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reminderCancel.ff5408a7.svg";
export { ForwardRef as ReactComponent };